import { useState, useEffect } from "react";
import { ComboBoxListOption } from "../components/core/ComboBox";
import { useDebounce } from "../components/hookHelpers";
const useComboBox = ({
  fetchOptions,
  allowEmptyQuery = false,
}: {
  allowEmptyQuery?: boolean;
  fetchOptions: (query: string) => Promise<ComboBoxListOption[]>;
}) => {
  const [options, setOptions] = useState<ComboBoxListOption[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  const [isSearching, setIsSearching] = useState(false);
  const [value, setValue] = useState<ComboBoxListOption | null | undefined>(null);
  useEffect(() => {
    const search = async () => {
      if (!allowEmptyQuery && !debouncedSearchTerm) {
        setOptions([]); // Clear options when search term is empty
        return;
      }

      try {
        setIsSearching(true);
        const fetchedOptions = await fetchOptions(debouncedSearchTerm);
        setOptions(fetchedOptions);
      } catch (error) {
      } finally {
        setIsSearching(false);
      }
    };

    search();
  }, [debouncedSearchTerm, fetchOptions, allowEmptyQuery]);

  return {
    options,
    isSearching,
    searchTerm,
    setSearchTerm,
    value,
    setValue
  };
};

export default useComboBox;
